"use strict";

import angular from "angular";

import template from "./help-center-button.component.html";
import "./themes/help-center-button.component.scss";

class HelpCenterButtonComponent {
    constructor($element, CentralSidenavService) {
        this.$element = $element;
        this.CentralSidenavService = CentralSidenavService;

        this.isMouseDown = false;
        this.initX = this.initY = this.height = this.$element[0].firstChild.offsetHeight;
    }

    $onInit() {
        this._setDraggable();
    }

    $onDestroy() {}

    $onChanges(changes) {}

    _setDraggable() {
        this.$element[0].firstChild.addEventListener("mousedown", (e) => {
            this.isMouseDown = true;
            this.initX = e.offsetX;
            this.initY = e.offsetY;
        });

        document.addEventListener("mousemove", (e) => {
            if (this.isMouseDown) {
                this.CentralSidenavService.blockOpen = true;
                let cx = e.clientX - this.initX,
                    cy = e.clientY - this.initY;
                if (cx < 0) {
                    cx = 0;
                }
                if (cy < 0) {
                    cy = 0;
                }
                if (window.innerWidth - e.clientX + this.initX < this.width) {
                    cx = window.innerWidth - this.width;
                }
                if (e.clientY > window.innerHeight - this.height + this.initY) {
                    cy = window.innerHeight - this.height;
                }
                //this.$element[0].firstChild.style.left = cx + "px";
                this.$element[0].firstChild.style.top = cy - 20 + "px";

                setTimeout(() => {
                    this.CentralSidenavService.blockOpen = false;
                }, 2500);
            }
        });

        this.$element[0].firstChild.addEventListener("mouseleave", () => {
            this.isMouseDown = false;
        });

        this.$element[0].firstChild.addEventListener("mouseup", () => {
            this.isMouseDown = false;
        });
    }
}

HelpCenterButtonComponent.$inject = ["$element", "CentralSidenavService"];

const name = "helpCenterButtonComponent";
const def = {
    bindings: {},
    controller: HelpCenterButtonComponent,
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
